import axios from 'axios';
import { CommonRootState } from '../combineReducers';
import { FilterOptionValueType } from '@pec/aion-ui-odata/types/odataFilterOption';
import { ITask } from '../interfaces/task';
import { OdataComparator } from '@pec/aion-ui-odata/types/odataComparator';
import { QueryBuilder } from '@pec/aion-ui-odata/builders/odataQueryBuilder';
import { sendError } from '../sendError';
import { TaskStatus } from '../interfaces/taskGroup';
import { ThunkAction } from 'redux-thunk';

const { Equals, In } = OdataComparator;
const { AssigneeReplied, Incomplete, OwnerReplied, Submitted } = TaskStatus;

const fetchTasksCountSuccess = (payload: number) =>
  ({
    type: 'FETCH_TASKS_COUNT_SUCCESS',
    payload
  } as const);

const getClientParams = (organizationId: string) =>
  new QueryBuilder()
    .top(0)
    .filter(f =>
      f.filterBy('clientId', Equals, organizationId).filterBy('status', In, [AssigneeReplied, Submitted], {
        valueType: FilterOptionValueType.EnumType
      })
    )
    .toQueryParam();

const getContractorParams = (organizationId: string) =>
  new QueryBuilder()
    .top(0)
    .filter(f =>
      f.filterBy('contractorId', Equals, organizationId).filterBy('status', In, [Incomplete, OwnerReplied], {
        valueType: FilterOptionValueType.EnumType
      })
    )
    .toQueryParam();

export const fetchTasksCount = (
  organizationId: string,
  isAssignee: boolean
): ThunkAction<void, CommonRootState, null, Actions> => async dispatch => {
  try {
    const params = isAssignee ? getContractorParams(organizationId) : getClientParams(organizationId);

    const { data } = await axios.get<{ value: ITask[]; '@odata.count': number }>('/api/v3.01/contractorTasks', {
      params
    });

    dispatch(fetchTasksCountSuccess(data['@odata.count']));
  } catch (error) {
    sendError(error);
  }
};

export type Actions = ReturnType<typeof fetchTasksCountSuccess>;
